import type { CSSProperties } from 'react';

export interface SkeletonProps {
  variant?: 'line' | 'block' | 'circle';
  className?: string;
  style?: CSSProperties;
}

/** Shimmering placeholder ??? reads as structure, not as an error. */
export function Skeleton({ variant = 'line', className = '', style }: SkeletonProps) {
  return (
    <span
      className={`sk sk--${variant} ${className}`.trim()}
      style={style}
      aria-hidden="true"
    />
  );
}

export function JobCardSkeleton() {
  return (
    <div className="jobcard jobcard--skeleton" aria-hidden="true">
      <div className="jobcard__top">
        <Skeleton variant="line" style={{ width: 96 }} />
        <Skeleton variant="line" style={{ width: 64 }} />
      </div>
      <div className="jobcard__route">
        <Skeleton variant="circle" style={{ width: 10, height: 10 }} />
        <Skeleton variant="line" style={{ width: '70%' }} />
        <Skeleton variant="circle" style={{ width: 10, height: 10 }} />
        <Skeleton variant="line" style={{ width: '55%' }} />
      </div>
      <div className="jobcard__meta">
        <Skeleton variant="line" style={{ width: 56 }} />
        <Skeleton variant="line" style={{ width: 72 }} />
        <Skeleton variant="line" style={{ width: 64 }} />
      </div>
    </div>
  );
}

export function JobsSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div data-testid="jobs-skeleton" aria-label="Loading jobs" role="status">
      {Array.from({ length: count }, (_, i) => (
        <JobCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function DetailSkeleton() {
  return (
    <div data-testid="detail-skeleton" aria-label="Loading job" role="status">
      <Skeleton variant="block" style={{ height: 96, borderRadius: 8 }} />
      <div style={{ height: 12 }} />
      <Skeleton variant="block" style={{ height: 140, borderRadius: 8 }} />
      <div style={{ height: 12 }} />
      <Skeleton variant="block" style={{ height: 180, borderRadius: 8 }} />
    </div>
  );
}
